<template>
  <OnexPage>
    <v-row class="bg-blueGrey200" no-gutters>
      <v-col justify="center" class="d-flex">
        <v-img
          src="../assets/primerica-logo.svg"
          alt=""
          :width="260"
          :max-width="260"
          class="mb-4 mt-2 mx-auto"
      /></v-col>
    </v-row>
    <div v-if="agentExists" class="bg-white mx-auto">
      <div>
        <AgentDetailsCRM
          :agent-data-retreived="pegaCRMJSON"
          :is-preview="previewExists"
        ></AgentDetailsCRM>
        <PreferencesList
          v-if="pegaCRMJSON?.preferences?.landingpages?.length"
          :preferences="pegaCRMJSON.preferences?.landingpages"
          :is-preview="previewExists"
        ></PreferencesList>
        <LifeStyleArticle v-if="pegaReturnHTML" :article-file="pegaReturnHTML"></LifeStyleArticle>
        <EmailForm
          v-if="pegaCRMJSON?.preferences?.isneedhelp"
          :agent-data="pegaCRMJSON?.agentInfo"
          :is-preview="previewExists"
        ></EmailForm>
        <ServicesList
          :agent-data-retreived="pegaCRMJSON"
          :is-preview="previewExists"
        ></ServicesList>
      </div>
      <DisclosuresList
        :default-language="pegaCRMJSON?.defaultlanguage"
        :disclosures="pegaCRMJSON?.disclosures"
        :is-preview="previewExists"
        :bg-color="'bg-grey-lighten-3'"
      ></DisclosuresList>
    </div>
  </OnexPage>
</template>

<script lang="ts">
import EmailForm from '@/components/EmailForm.vue';
import PreferencesList from '@/components/PreferencesList.vue';
import LifeStyleArticle from '@/components/LifeStyleArticle.vue';
import AgentDetailsCRM from '@/components/AgentDetailsCRM.vue';
import ServicesList from '@/components/ServicesList.vue';
import DisclosuresList from '@/components/DisclosuresList.vue';
import { defineComponent } from 'vue';
import type { CRMAgentDetails } from '@/interfaces/PegaAgent';
import { Translations } from '@/i18n/models';
import { OnexPage } from '@primerica/onex-ui-lib';
import PegaApiStore from '@/stores/pegaApi.store';
import { mapState } from 'pinia';

export default defineComponent({
  name: 'MainContent',
  components: {
    PreferencesList,
    LifeStyleArticle,
    DisclosuresList,
    ServicesList,
    AgentDetailsCRM,
    EmailForm,
    OnexPage,
  },
  data() {
    return {
      pegaStore: PegaApiStore(),
      Translations,
    };
  },
  computed: {
    ...mapState(PegaApiStore, ['pegaCRMJSON', 'pegaReturnHTML', 'locale']),
    agentData(): CRMAgentDetails | null {
      return this.pegaCRMJSON;
    },
    agentExists(): boolean {
      return !!Object.keys(this.pegaCRMJSON ?? {}).length;
    },
    previewExists(): boolean {
      return !!this.$route.query.preview;
    },
  },
  async created() {
    await this.pegaStore.setCRMAgentDetails(this.previewExists, this.$router);
    this.$i18n.locale = this.pegaStore.locale;
  },
});
</script>
<style lang="scss" scoped>
:deep(#onex-page__default) {
  background-color: #e7edf3 !important;
}

.primerica-logo {
  background-color: #e7edf3 !important;
}

:deep(#onex-page__default--content) {
  max-width: 800px !important;
  padding: 0 !important;
}
</style>
